import { render, staticRenderFns } from "./delivery-contract-history-order.vue?vue&type=template&id=bf7f96d8"
import script from "./delivery-contract-history-order.vue?vue&type=script&lang=js"
export * from "./delivery-contract-history-order.vue?vue&type=script&lang=js"
import style0 from "./delivery-contract-history-order.vue?vue&type=style&index=0&id=bf7f96d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports